/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <React.Fragment>
    <path
      fill="currentColor"
      d="M4 18.4a.75.75 0 1 1 1.5 0 .75.75 0 0 1-1.5 0ZM7.75 17.65a.75.75 0 0 0 0 1.5h11.5a.75.75 0 0 0 0-1.5H7.75Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M1 5c0-1.6568 1.3432-3 3-3h16c1.6569 0 3 1.3432 3 3v14c0 1.6569-1.3431 3-3 3H4c-1.6568 0-3-1.3431-3-3V5Zm3-1.5h16c.8284 0 1.5.6716 1.5 1.5v10.6273a3.4842 3.4842 0 0 0-2-.6273h-15c-.7436 0-1.433.2319-2 .6273V5c0-.8284.6716-1.5 1.5-1.5Zm.5 17c-1.1046 0-2-.8954-2-2s.8954-2 2-2h15c1.1046 0 2 .8954 2 2s-.8954 2-2 2h-15Z"
      clipRule="evenodd"
    />
  </React.Fragment>,
  'Storage'
);
